import { Cell, CellWithHierarchy } from '@pelckmans/elementis/components/table';
import { ComponentProps, useContext } from 'react';
import HorizontalScrollContext from '../../../../../shared-components/table/context/HorizontalScrollContext';
import { getResultPercentages, getStatusForScorableItem } from '../../../../../utils/results';
import { TableDataRow } from '../types';

export const TableRow = ({ row, detailView }: { row: TableDataRow; detailView: boolean }) => {
  const { horizontalScroll } = useContext(HorizontalScrollContext);

  const subTitle =
    row.subTitleBot || row.subTitleTop
      ? {
          text: row.subTitleBot || row.subTitleTop || '',
          position: row.subTitleBot ? ('bottom' as const) : ('top' as const),
        }
      : undefined;

  const cell = row.href ? (
    <Cell.Link title={row.title} startAdornment={row.icon} subTitle={subTitle} linkProps={{ to: row.href }} />
  ) : (
    <Cell.Text title={row.title} startAdornment={row.icon} subTitle={subTitle} />
  );

  return (
    <tr data-testid={row.id} key={row.id}>
      <CellWithHierarchy
        hierarchyProps={{
          level: row.level as ComponentProps<typeof CellWithHierarchy>['hierarchyProps']['level'],
          hasCollapsibleParent: true,
        }}
        sticky={!detailView && horizontalScroll}
        className="scorable-item-column"
        minWidth="xl"
        maxWidth="xl"
      >
        {cell}
      </CellWithHierarchy>
      {row.columns.map((column, i) => {
        if (column && 'Cell' in column) {
          const CustomCell = column.Cell;
          return <CustomCell key={column.id} />;
        }

        const status = column && getStatusForScorableItem(column);

        return column ? (
          <Cell key={`${column.exerciseId}-${column.isAssignment}-${column.memberId}`} minWidth="xs" maxWidth="xs">
            <span className="results-cell">
              <Cell.Results
                {...getResultPercentages(column.score, column.needsGrading)}
                quantifiable={!column.unachievable && column.score?.achieved !== -1}
                status={status}
                showTooltip
                variant="donut"
              />
            </span>
          </Cell>
        ) : (
          <Cell key={i} />
        );
      })}
    </tr>
  );
};
